module.exports = __webpack_public_path__ + "static/mm_home-3b990d7339a9f4e03aacb20f11ba791e.jpg";